import { useSamplePackRemixes } from '../../../__legacy__/queries/samplePacks'
import { ArpTableContextData } from '../components'
import { DEFAULT_GET_ARP_MEDIA_PARAMS } from './useArpTable'

export const useSPRemixTable = (id: number): ArpTableContextData<any> => {
  const {
    data: rawData,
    fetchNextPage,
    hasNextPage: hasMore,
    status: rawStatus
  } = useSamplePackRemixes({ id, params: DEFAULT_GET_ARP_MEDIA_PARAMS })
  const data = rawData?.pages.flatMap((page) => page.data) || []
  const status = rawStatus === 'success' ? 'ready' : rawStatus
  const updateFilters = () => {}
  return {
    data,
    hasMore,
    status,
    nextPage: fetchNextPage,
    updateFilters,
    filters: {},
    defaultFilters: {}
  }
}
